<template>
    <div>
        <div class="_flex">
            <el-input placeholder="姓名" v-model="search.nick_name" size="small" style="width: 150px;margin-left: 10px;"/>
            <el-input placeholder="手机号" v-model="search.phone" size="small" style="width: 150px;margin-left: 10px;"/>
            <div class="_button nul mr_10 ml_10" @click="getAdminLists(1)">筛选</div>
            <div class="_button bag_red" @click="clearSelection">清空选择({{selectedAdmins.length}})</div>
        </div>
        <div class="_flex_sb mt_20">
            <div class="left bag_f5 p_10 br_8" style="width: 150px;">
                <el-scrollbar style="height: 60vh;">
                    <el-tree :data="departArr" :props="defaultProps" node-key="id" :default-expand-all="false" :default-expanded-keys="defaultExpandedKeys"  :expand-on-click-node="false" @node-click="selectDepart"></el-tree>
                </el-scrollbar>
            </div>
            <div class="right" style="width: calc(100% - 180px);">
                <el-table :data="adminArr" height="60vh" :header-cell-style="{ background:'#f5f5f5'}" row-key="admin_id"
                    ref="multipleTable" style="width: 100%"
                    :highlight-current-row="!multi"
                    @selection-change="handleSelectionChange"
                    @current-change="handleCurrentChange"
                >
                    <el-table-column type="selection" width="55" :reserve-selection="true" v-if="multi"></el-table-column>
                    <el-table-column prop="nick_name" label="姓名" ></el-table-column>
                    <el-table-column prop="phone" label="手机号" ></el-table-column>
                    <el-table-column prop="group_name" label="职务" ></el-table-column>
                </el-table>
                <el-pagination background style="margin-top: 10px;" layout="total, sizes, prev, pager, next"
                    @size-change="changeLimit" @current-change="changePage"
                    :current-page="search.page" :page-size="search.limit" :total="search.total" :page-sizes="[10, 50, 100, 200, 300, 500]"
                >
                </el-pagination>
            </div>
        </div>
        <div class="t_c mt_40">
            <el-button @click="close">取 消</el-button>
            <el-button type="success" @click="submit">确 定</el-button>
        </div>
    </div>
</template>

<script>
import { adminLists, roleLists, DepartmentLists } from "@/request/apis.js"

export default {
    name: 'AdminSelect',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        multi: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            search: {
                nick_name: '',
                phone: '',
                depart_id: 0,
                page: 1,
                limit: 10,
                total: 0,
            },
            departArr: [],
            adminArr: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            selectedAdmins: [],
            toggleFinish: false,
            defaultExpandedKeys: [],
        }
    },
    computed: {

    },
    mounted() {
        this.getDepartmentLists();
        this.getAdminLists();
        this.selectedAdmins = JSON.parse(JSON.stringify(this.value));
    },
    methods: {
        async getAdminLists(page = 0, depart_id = 0){
            if(page){
                this.search.page = page;
            }
            var res = await adminLists({...this.search, depart_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.adminArr = res.data;
            this.search.total = res.count;

            this.$nextTick(() => {
                this.toggleFinish = false;
                this.adminArr.forEach(row => {
                    if (this.selectedAdmins.some(selected => selected.admin_id === row.admin_id)) {
                        console.log('inittableSelect', this.selectedAdmins)
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                });
                this.toggleFinish = true;
            });
        },
        changeLimit(limit){
            this.search.limit = limit;
            this.getAdminLists();
        },
        changePage(page){
            this.getAdminLists(page);
        },
        async getDepartmentLists(){
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
            this.defaultExpandedKeys = this.getExpandedNodeIds(this.departArr);
        },
        // 获取需要展开的节点 ID
        getExpandedNodeIds(nodes, level = 1, maxLevel = 2) {
            let ids = [];
            
            if (level <= maxLevel && nodes) {
                nodes.forEach(node => {
                    // 只展开前三级，第三级不展开子节点
                    if (level < maxLevel) {
                        ids.push(node.id);
                    }
                    
                    if (node.children && node.children.length > 0 && level < maxLevel) {
                        ids = ids.concat(this.getExpandedNodeIds(node.children, level + 1, maxLevel));
                    }
                });
            }
            
            return ids;
        },
        selectDepart(data){
            this.getAdminLists(1, data.id);
        },
        handleSelectionChange(selection) {
            if(!this.toggleFinish){
                return;
            }
            console.log('handleSelectionChange', selection)
            let currentIdArr = this.adminArr.map(item => item.admin_id);
            let selectionIdArr = selection.map(item => item.admin_id);
            let removeIdArr = currentIdArr.filter(id => !selectionIdArr.includes(id));
            this.selectedAdmins = this.selectedAdmins.filter(item => !removeIdArr.includes(item.admin_id));
            let selectedIdArr = this.selectedAdmins.map(item => item.admin_id);
            selection.forEach(ele => {
                if(!selectedIdArr.includes(ele.admin_id)){
                    this.selectedAdmins.push(ele);
                }
            });
            // this.$emit('input', this.selectedAdmins);
        },
        close(){
            this.$emit('close');
        },
        submit(){
            this.$emit('input', this.selectedAdmins);
            this.$emit('close');
        },
        handleCurrentChange(val) {
            if(this.multi){
                this.selectedAdmins = [val];
            }
        },
        clearSelection() {
            this.$refs.multipleTable.clearSelection();
            this.selectedAdmins = [];
        }
    }
}
</script>

<style scoped>
</style>